var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"getFile":_vm.getFile}},[_c('a-input',{attrs:{"type":"text","id":"file_package","name":"file","placeholder":"请输入文件夹名"}}),_c('a-input',{attrs:{"type":"text","id":"file_name","name":"file","placeholder":"请输入文件名"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }